// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3KDCB","addWidgetButton":"Header_addWidgetButton__3_Mqb","dashboardTabs":"Header_dashboardTabs__3Yjo5","active":"Header_active__10j8j"};